<template>
  <div id="device-info" class="scroll-vertical">
    <content-nav-bar>
      <p class="level-item is-size-4">Organization Information</p>
    </content-nav-bar>
    <detail-item
      v-for="item in values"
      :key="item.label"
      :name="item.label"
      :imgName="item.icon">
      {{ item.value }}
    </detail-item>
  </div>
</template>s

<script>
import organization from '@/mixins/admin/organizations';
import DetailItem from '@/components/DetailItem.vue';
import ContentNavBar from '@/components/ContentNavBar.vue';

export default {
  name: 'OrganizationDetails',
  mixins: [organization],
  components: { ContentNavBar, DetailItem },
  props: {
    organization: {
      type: Object,
      required: true,
    },
  },
  computed: {
    values() {
      return this.keyValues(this.organization);
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
